import { render, staticRenderFns } from "./Premios.vue?vue&type=template&id=5133ae91&scoped=true&"
import script from "./Premios.vue?vue&type=script&lang=js&"
export * from "./Premios.vue?vue&type=script&lang=js&"
import style0 from "./Premios.vue?vue&type=style&index=0&id=5133ae91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133ae91",
  null
  
)

export default component.exports